import { Station } from '@mi-front/core';

export function useYoutubeStatsEnabled(station: Station) {
  return Boolean(station.youtubeChannelId);
}
